import { NumberInput } from '@mews-commander/ui';
import { IconButton, IconName } from '@optimus-web/core';

interface Props {
    basePriceBulkValue?: number;
    handleOnClick: () => void;
    hasRowsSelected: boolean;
    setBasePriceBulkValue: (value?: number) => void;
}

export const PriceBulkActions = ({
    basePriceBulkValue,
    handleOnClick,
    hasRowsSelected,
    setBasePriceBulkValue,
}: Props) => (
    <>
        <NumberInput
            type="number"
            name="BasePriceBulk"
            placeholder="00.00"
            size="small"
            disabled={!hasRowsSelected}
            onChange={(value) => setBasePriceBulkValue(value)}
        />
        <IconButton
            type="button"
            icon={IconName.Refresh}
            size="small"
            variant={hasRowsSelected ? 'primary' : 'secondary'}
            disabled={(basePriceBulkValue && basePriceBulkValue < 0) || !hasRowsSelected}
            onClick={handleOnClick}
        />
    </>
);
